/**
 * Converts a text title into a clean, URL-safe slug (without accents or special chars)
 * Example: "Casa en Venta en Las Quintas, Hidalgo del Parral" -> "casa-en-venta-en-las-quintas-hidalgo-del-parral"
 */
export const slugify = (text) => {
  if (!text) return '';
  return text
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '');
};

/**
 * Returns the best slug for a property (uses property.slug or slugifies property.title)
 */
export const getPropertySlug = (property) => {
  if (!property) return '';
  if (property.slug && property.slug.trim()) {
    return slugify(property.slug);
  }
  if (property.title && property.title.trim()) {
    return slugify(property.title);
  }
  return property.id || '';
};
